import SnippetEditor from 'models/location/snippet_editor';

export default class NavigateToCloneSnippet {
  constructor(context) {
    this.context = context;
  }

  run(cloneId) {
    this.context.router.navigateTo(SnippetEditor.create({ cloneId }));
  }
}
